import React from 'react';
import { useMutation } from 'urql';
import { EVENT_NAMES } from 'analytics/constants';
import { track } from 'analytics/utilities';
import errorParser from 'utilities/graphql/errorParser';
import errorParserWithValidation from 'utilities/graphql/errorParserWithValidation';
import useDeepCompareEffect from 'hooks/useDeepCompareEffect';
import { reduceVariables } from './helpers';

export const useDataMutation = (queryObject) => {
  const { query, enableFieldValidation } = queryObject;
  const [result, executeMutation] = useMutation(query);
  // why would we ever reduce the variables passed to the mutation
  // @todo remove this reduction should happen to the response
  const executeMutationWithReducer = reduceVariables(executeMutation, queryObject);

  // The new error parser (with field validations included) is a breaking change.
  // To avoid the need of adapting all the mutations at once, we added the 'enableFieldValidation'
  // attribute to the query object. This makes it possible to tell a specific mutation to use the
  // new error parser, so we can gradually change and test the mutations.
  const parseError = enableFieldValidation ? errorParserWithValidation : errorParser;
  useDeepCompareEffect(() => {
    if (result.error) {
      track(EVENT_NAMES.ERROR, result);
    }
    if (!result.fetching && result.data) {
      track(EVENT_NAMES.MUTATION, result);
    }
  }, [result]);

  return [{
    ...result,
    error: parseError(result.error),
  }, executeMutationWithReducer];
};

export const withMutation = (Component) => (mutation) => {
  const MutationComponent = (props) => {
    const [mutationRes, mutationHandler] = useDataMutation(mutation);
    return <Component {...props} res={mutationRes} mutationHandler={mutationHandler} />;
  };

  return MutationComponent;
};
